import ModalProvider from "../contexts/ModalProvider";
import useTheme from "../hooks/useTheme";

function MainLayout({ children }) {
  // Apply theme based on customer type for all pages
  useTheme();

  return (
    <>
      <ModalProvider>{children}</ModalProvider>
    </>
  );
}

export default MainLayout;
